import React, { ReactNode } from 'react';

import { ClassName, GADataType } from '../../../../types';
import { TeamLinkTeam } from './TeamLink.types';

import { useCurrentUser } from '../../../../auth/hooks/useAuth';

import { NextLinkHelper } from '../../../../helpers/links/NextLinkHelper';

import { TeamPath } from '../../TeamPath';

import { TeamsPermissions } from '../../teamsConstants';

interface TeamLinkDefaultProps {
  className?: ClassName;
  team: TeamLinkTeam;
  withLibraryLink?: boolean;
}

interface TeamLinkWithChildrenProps {
  text?: never;
  children: ReactNode;
}

interface TeamLinkWithTextProps {
  text: string;
  children?: never;
}

type TeamLinkProps = TeamLinkDefaultProps &
  (TeamLinkWithChildrenProps | TeamLinkWithTextProps) &
  GADataType;

function TeamLink({
  children,
  className,
  dataGa,
  team,
  text,
  withLibraryLink
}: TeamLinkProps) {
  const currentUser = useCurrentUser();

  const canReadProfileLink = currentUser.hasPermissions(
    TeamsPermissions.READ_COMPANY_PROFILE_LINK
  );

  const canReadLibraryLink = currentUser.hasPermissions(
    TeamsPermissions.READ_COMPANY_LIBRARY_LINK
  );

  let href = '#';

  if (canReadProfileLink) {
    href = TeamPath.companyProfile(team.nanoId);
  }

  if (withLibraryLink && canReadLibraryLink) {
    href = TeamPath.companyNewLibraryProducts(team.nanoId);
  }

  return (
    <NextLinkHelper
      className={className}
      href={href}
      title={team.name}
      dataGa={dataGa}
    >
      {text || children}
    </NextLinkHelper>
  );
}

export default TeamLink;
